import { KontentVideo, Video } from "../types";
import { formatImages } from "./images";

export function formatVideo(video: KontentVideo["elements"]): Video {
  return {
    videoUrl: video.video_url?.value,
    description: video.description?.value,
    name: video.name?.value,
    thumbnail: formatImages(video.thumbnail.value[0]?.elements).largeImage,
    uploadDate: video.upload_date?.value,
  };
}
